/* unplugin-vue-components disabled */import { render } from "./lsDetailScript.vue?vue&type=template&id=4bedc5fb"
import script from "./lsDetailScript.vue?vue&type=script&lang=js"
export * from "./lsDetailScript.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__